<template>
  <public-layout>
    <div class="container mx-auto p-6 content-center md:py-12 lg:px-0 md:w-1/2 xl:w-1/3">
      <div class="flex flex-col px-6 py-8 border border-gray-100 shadow-2xl rounded bg-white lg:px-12">
        <forgot-form />
      </div>
      <div class="p-2 w-full py-3 mt-12 border-t border-gray-200 text-center">
        <div class="inline-flex space-x-4">
          <a
            class="text-gray-500 hover:text-purple-500"
            @click="$router.push({ name: 'help-center.index' })">
            &nbsp;
          </a>
        </div>
      </div>
    </div>
  </public-layout>
</template>
<script>
export default {
  name: 'ForgotIndex',
  components: {
    PublicLayout: () => import('@/components/layouts/PublicLayout'),
    ForgotForm: () => import('./ForgotForm'),
  },
}
</script>
